module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"choose-picker":"Цвет иконки","return":"Вернуться","filter-placeholder":"Поиск по имени"},"en":{"choose-picker":"Icon color","return":"Return","filter-placeholder":"Search by name"}}')
  delete Component.options._Ctor
}
